<template>
  <div class="relative flex">
    <input
      type="text"
      :placeholder="placeholder"
      v-model="model"
      class="form-input w-full appearance-none rounded-[6px] border-0 bg-bg-1 py-[11px] pl-[22px] pr-[40px] text-xs text-gpx_black-500 placeholder:text-gpx_gray-200 focus:ring-0"
    />
    <MagnifyingGlassIcon
      class="heroicon-stroke-w-1.2 absolute right-[16px] top-1/2 h-[18px] w-[18px] -translate-y-1/2 text-gpx_gray-400"
      v-if="!modelValue && !typing"
    />
    <XMarkIcon
      class="heroicon-stroke-w-1.2 absolute right-[16px] top-1/2 h-[18px] w-[18px] -translate-y-1/2 cursor-pointer text-gpx_gray-400"
      v-if="modelValue && !typing"
      @click="model = null"
    />
    <Spinner
      class="absolute right-[16px] top-1/2 -translate-y-1/2"
      size="xs"
      v-if="modelValue && typing"
    />
  </div>
</template>

<script>
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/vue/24/outline'
import Spinner from "./Spinner.vue";

export default {
  props: {
    placeholder: {
      type: String,
      required: true
    },
    modelValue: {
      type: String
    }
  },

  emits: ['update:modelValue'],

  components: {
    Spinner,
    MagnifyingGlassIcon,
    XMarkIcon
  },

  data() {
    return {
      typing: false,
      timeoutId: null
    }
  },

  computed: {
    model: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },

  watch: {
    model: function () {
      if (this.modelValue) {
        this.typing = true
        this.timeoutId = setTimeout(() => {
          this.typing = false
        }, 500)
      } else {
        this.typing = false
        if (typeof this.timeoutId === 'number') {
          clearTimeout(this.timeoutId)
        }
      }
    }
  }
}
</script>
